import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-71" data-mp="e3dirvkbfkrm">
      <div className="mx-auto max-w-6xl" data-id="element-72" data-mp="9mg9750515e">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-73" data-mp="58z49v7m0e9k">
          <div className="lg:col-span-7" data-id="element-74" data-mp="574iyfsfek4y">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-75" data-mp="3mguja2sg8vy9">設計科技備課寶™ 帶來的分別</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-76" data-mp="3rgyrz6n48mdx">
              由手忙腳亂，<em className="text-red-700" data-id="element-77" data-mp="3dhzdgrtbhnvh">變成從容備課。</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-78" data-mp="3ieza6c4a1e9x">
            想像一下，每個星期一開始，設計與科技課已經安排好。你知道要教甚麼——工作紙、圖解、專題、安全守則和評估表都已經準備好。
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-79" data-mp="1goxkcj17g0ka">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-80" data-mp="1ja3z75awquee" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-81" data-mp="1t0p57dswv17c">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-82" data-mp="1o1vutu8x7qbe">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-83" data-mp="10bjcrqjyod73">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-84" data-mp="10e4f0go68v5d">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-85" data-mp="wd2dft6s8708">用設計科技備課寶™ 之前</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-86" data-mp="1abscvfh2qirr">
              是否似曾相識？
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-87" data-mp="2lpe0uxb76ebp">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-88" data-mp="2grcf24me00wj">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-89" data-mp="2oq7fv4b318qg" />
                  <span data-id="element-90" data-mp="2srszd8i4gl9m">
                    <span className="block font-semibold text-slate-900/80" data-id="element-91" data-mp="2sr127t8vmfh8">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-92" data-mp="32oxlj8bywgqf">
            <p className="text-sm font-semibold text-red-300" data-id="element-93" data-mp="251f5rdjw2ecx">用設計科技備課寶™ 之後</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-94" data-mp="2a2maf3qqixfd">
              備課更少，教學更多。
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-95" data-mp="2js5ugcq6oxbt">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-96" data-mp="1md1qoimrbw51">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-97" data-mp="1rblfcqsqjm13">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-98" data-mp="1jslx4oh0g0jb" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-99" data-mp="19suz4ct8r3eh">
          把心思放在學生身上，而不是自己做所有教材。
        </p>
      </div>
    </section>;
}